import { ReactElement } from 'react'

import { lazyWithRetry } from 'utils'

const EmailLanding = lazyWithRetry(() =>
  import('../../post-quote/pages/EmailLanding').then((module) => ({
    default: module.EmailLanding,
  })),
)
const DirectLanding = lazyWithRetry(() =>
  import('../../post-quote/pages/DirectLanding').then((module) => ({
    default: module.DirectLanding,
  })),
)
const ContinueQuote = lazyWithRetry(() =>
  import('../../post-quote/pages/ContinueQuote/ContinueQuote').then((module) => ({
    default: module.ContinueQuote,
  })),
)
const ComparatorLanding = lazyWithRetry(() =>
  import('../../post-quote/pages/ComparatorLanding').then((module) => ({
    default: module.ComparatorLanding,
  })),
)
const PlanComparison = lazyWithRetry(() =>
  import('../../post-quote/pages/PlanComparison').then((module) => ({
    default: module.PlanComparison,
  })),
)
const Overview = lazyWithRetry(() =>
  import('../../post-quote/pages/Overview').then((module) => ({ default: module.Overview })),
)
const VehicleVerification = lazyWithRetry(() =>
  import('../../post-quote/pages/VehicleVerification/VehicleVerification').then((module) => ({
    default: module.VehicleVerification,
  })),
)
const GeneralAddOns = lazyWithRetry(() =>
  import('../../post-quote/features/addOns/GeneralAddOns').then((module) => ({
    default: module.GeneralAddOns,
  })),
)

const BreakdownAddOn = lazyWithRetry(() =>
  import('../../post-quote/features/addOns/BreakdownAddOn').then((module) => ({
    default: module.BreakdownAddOn,
  })),
)
const OwnershipAdditionalQuestions = lazyWithRetry(() =>
  import('../../post-quote/pages/AdditionalQuestions/OwnershipAdditionalQuestions').then(
    (module) => ({
      default: module.OwnershipAdditionalQuestions,
    }),
  ),
)
const PreviousCancellationAdditionalQuestions = lazyWithRetry(() =>
  import('../../post-quote/pages/AdditionalQuestions/PreviousCancellationAdditionalQuestions').then(
    (module) => ({
      default: module.PreviousCancellationAdditionalQuestions,
    }),
  ),
)
const PreviousCancellationYearAdditionalQuestions = lazyWithRetry(() =>
  import(
    '../../post-quote/pages/AdditionalQuestions/PreviousCancellationYearAdditionalQuestions'
  ).then((module) => ({
    default: module.PreviousCancellationYearAdditionalQuestions,
  })),
)
const LicenceCountryAdditionalQuestions = lazyWithRetry(() =>
  import('../../post-quote/pages/AdditionalQuestions/LicenceCountryAdditionalQuestions').then(
    (module) => ({
      default: module.LicenceCountryAdditionalQuestions,
    }),
  ),
)
const NcdAdditionalQuestions = lazyWithRetry(() =>
  import('../../post-quote/pages/AdditionalQuestions/NcdAdditionalQuestions').then((module) => ({
    default: module.NcdAdditionalQuestions,
  })),
)
const StudentAdditionalQuestions = lazyWithRetry(() =>
  import('../../post-quote/pages/AdditionalQuestions/StudentAdditionalQuestions').then(
    (module) => ({
      default: module.StudentAdditionalQuestions,
    }),
  ),
)
const CreateAccount = lazyWithRetry(() =>
  import('../../post-quote/pages/CreateAccount').then((module) => ({
    default: module.CreateAccount,
  })),
)
const Statements = lazyWithRetry(() =>
  import('../../post-quote/pages/Statements').then((module) => ({ default: module.Statements })),
)
const Summary = lazyWithRetry(() =>
  import('../../post-quote/pages/Summary').then((module) => ({ default: module.Summary })),
)
const Payment = lazyWithRetry(() =>
  import('../../post-quote/features/payments/Payment').then((module) => ({
    default: module.Payment,
  })),
)
const PaymentSuccess = lazyWithRetry(() =>
  import('../../post-quote/features/payments/Payment').then((module) => ({
    default: module.PaymentSuccess,
  })),
)
const PaymentDecline = lazyWithRetry(() =>
  import('../../post-quote/features/payments/PaymentDecline').then((module) => ({
    default: module.PaymentDecline,
  })),
)
const ConnectYourBank = lazyWithRetry(() =>
  import('../../post-quote/features/payments/ConnectYourBank').then((module) => ({
    default: module.ConnectYourBank,
  })),
)
const ConnectYourBankRetry = lazyWithRetry(() =>
  import('../../post-quote/features/payments/ConnectYourBank').then((module) => ({
    default: module.ConnectYourBankRetry,
  })),
)
const WrongAccount = lazyWithRetry(() =>
  import('../../post-quote/features/payments/WrongAccount').then((module) => ({
    default: module.WrongAccount,
  })),
)
const OpenBankingErrorPage = lazyWithRetry(() =>
  import('../../Error/OpenBankingErrorPage').then((module) => ({
    default: module.OpenBankingErrorPage,
  })),
)
const ErrorPage = lazyWithRetry(() =>
  import('../../Error/ErrorPage').then((module) => ({ default: module.ErrorPage })),
)
const TimeoutPage = lazyWithRetry(() =>
  import('../../Error/TimeoutPage').then((module) => ({ default: module.TimeoutPage })),
)

type RouteParams = {
  path?: string
  component: ReactElement
  hideProgressBar?: boolean
}

export const postQuoteRoutes: RouteParams[] = [
  {
    path: '/quote/:quoteId/resume-from-email',
    component: <EmailLanding />,
  },
  {
    path: '/quote/:quoteId/continue-quote',
    component: <ContinueQuote />,
    hideProgressBar: true,
  },
  {
    path: '/quote/:quoteId/direct',
    component: <DirectLanding />,
  },
  {
    path: '/quote/:quoteId/compare-the-market',
    component: <ComparatorLanding comparator="compare-the-market" />,
  },
  {
    path: '/quote/:quoteId/go-compare',
    component: <ComparatorLanding comparator="go-compare" />,
  },
  {
    path: '/quote/:quoteId/confused',
    component: <ComparatorLanding comparator="confused" />,
  },
  {
    path: '/quote/:quoteId/uswitch',
    component: <ComparatorLanding comparator="uswitch" />,
  },
  {
    path: '/quote/:quoteId/quotezone',
    component: <ComparatorLanding comparator="quotezone" />,
  },
  {
    path: '/quote/:quoteId/money-supermarket',
    component: <ComparatorLanding comparator="money-supermarket" />,
  },
  {
    path: '/quote/:quoteId/connect-your-bank',
    component: <ConnectYourBank />,
  },
  {
    path: '/quote/:quoteId/connect-your-bank-retry',
    component: <ConnectYourBankRetry />,
  },
  {
    path: '/quote/:quoteId/connect-your-bank/error',
    component: <OpenBankingErrorPage />,
    hideProgressBar: true,
  },
  {
    path: '/quote/:quoteId/connect-your-bank/wrong-account',
    component: <WrongAccount />,
  },
  {
    path: '/quote/:quoteId/plan-comparison',
    component: <PlanComparison />,
  },
  {
    path: '/quote/:quoteId/overview/:version?',
    component: <Overview />,
  },
  {
    path: '/quote/:quoteId/vehicle-verification',
    component: <VehicleVerification />,
  },
  {
    path: '/quote/:quoteId/add-on/general',
    component: <GeneralAddOns />,
  },
  {
    path: '/quote/:quoteId/add-on/breakdown',
    component: <BreakdownAddOn />,
  },
  {
    path: '/quote/:quoteId/additional-questions/ownership',
    component: <OwnershipAdditionalQuestions />,
  },
  {
    path: '/quote/:quoteId/additional-questions/previous-cancellation',
    component: <PreviousCancellationAdditionalQuestions />,
  },
  {
    path: '/quote/:quoteId/additional-questions/previous-cancellation-year',
    component: <PreviousCancellationYearAdditionalQuestions />,
  },
  {
    path: '/quote/:quoteId/additional-questions/licence-country',
    component: <LicenceCountryAdditionalQuestions />,
  },
  {
    path: '/quote/:quoteId/additional-questions/ncd',
    component: <NcdAdditionalQuestions />,
  },
  {
    path: '/quote/:quoteId/additional-questions/student',
    component: <StudentAdditionalQuestions />,
  },
  {
    path: '/quote/:quoteId/statements',
    component: <Statements />,
  },
  {
    path: '/quote/:quoteId/summary',
    component: <Summary />,
  },
  {
    path: '/quote/:quoteId/payment/success',
    component: <PaymentSuccess />,
    hideProgressBar: true,
  },
  {
    path: '/quote/:quoteId/payment/:paymentPlan',
    component: <Payment />,
  },
  {
    path: '/quote/:quoteId/create-account',
    component: <CreateAccount />,
  },
  {
    path: '/quote/:quoteId/decline',
    component: <PaymentDecline />,
    hideProgressBar: true,
  },
]

export const miscsRoutes: RouteParams[] = [
  {
    path: '/quote/:quoteId/error',
    component: <ErrorPage />,
  },
  {
    path: '/quote/:quoteId/timeout',
    component: <TimeoutPage />,
  },
]
